import {Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faStar, faTimes} from "@fortawesome/free-solid-svg-icons";
import {useBoundStore} from "../../../Store/store";
import toast from "react-hot-toast";
import * as React from "react";
import {useForm} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import {TextAreaInput} from "../../Form/TextAreaInput";
import {PrimaryButton} from "../../Buttons/PrimaryButton";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";

export const RejectDialog = (props) => {
    const {
        isOpen,
        onClose,
        performanceStatementId,
        onSuccess
    } = props;

    const {t} = useTranslation();
    const rejectPerformanceStatement = useBoundStore((state) => state.rejectPerformanceStatement);

    const schema = yup.object({
        comment: yup.string().min(10).required(),
    }).required()

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues:{
            comment: null,
        }
    });

    useEffect(() => {
        console.log(errors)
    }, [errors]);

    const onSubmit = (data) => {
        rejectPerformanceStatement(performanceStatementId, data)
            .then(() => {
                onClose();
                toast.success(t('performance_reports.toast_rejected'));
                if (onSuccess) {
                    onSuccess();
                }
            })
    }

    return (
        <Dialog open={isOpen} onClose={() => onClose()} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300 ease-in-out data-[closed]:opacity-0"
            />
            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel className="w-full md:w-1/3 space-y-4 border bg-white p-12">
                    <div className="flex items-start justify-between flex-wrap">
                        <DialogTitle className="font-bold text-center">{t('registrations.reject_performance_title')}</DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                            <button
                                type="button"
                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                                onClick={() => onClose()}
                            >
                                <span className="absolute -inset-2.5"/>
                                <span className="sr-only">Close panel</span>
                                <FontAwesomeIcon icon={faTimes} className="h-6 w-6" aria-hidden="true"/>
                            </button>
                        </div>
                    </div>
                    <Description>{t('performance_reports.reject_reason')}</Description>

                    <form className={'grid grid-cols-1'} onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-2">
                            <TextAreaInput
                                register={register}
                                name={'comment'}
                                translationIndex={'general.fields.comment'}
                                errors={errors}
                            />
                        </div>

                        <div className="flex flex-row space-x-4 just">
                            <PrimaryButton onClick={handleSubmit(onSubmit)}>
                                {t('general.actions.send')}
                            </PrimaryButton>
                        </div>
                    </form>
                </DialogPanel>
            </div>
        </Dialog>
    )
}